import { ACTIONS_WB_ORDERS } from '../actions/wbOrders';

export const wbOrders = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_WB_ORDERS.ADD_MAP: {
      return { ...state, map: action.map };
    }
    case ACTIONS_WB_ORDERS.ADD_MAP_PART: {
      return { ...state, map: { ...state.map, ...action.map } };
    }
    case ACTIONS_WB_ORDERS.CHANGE_ORDER_MAP: {
      const { item } = action;
      // return { ...state, map: { ...state.map, [item.offer_id]: { ...state.map[item.offer_id], ...item } } };
      return { ...state, map: { ...state.map, [item.shop]: { ...state.map[item.shop], [item.offer_id]:  { ...state.map[item.shop][item.offer_id], ...item } } } };
    }

    default:
      return state;
  }
};
